var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 18.3C13.9098 17.91 13.9098 17.28 14.2998 16.89L18.1698 13H2.99978C2.44979 13 1.99978 12.55 1.99978 12C1.99978 11.45 2.44979 11 2.99978 11H18.1698L14.2898 7.11998C13.8998 6.72998 13.8998 6.09998 14.2898 5.70998C14.6798 5.31998 15.3098 5.31998 15.6998 5.70998L21.2998 11.3C21.6898 11.69 21.6898 12.32 21.2998 12.71L15.7098 18.3C15.3198 18.68 14.6798 18.68 14.2998 18.3Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.3297478e.svg";
export { ForwardRef as ReactComponent };